<template>
  <div>
    <div class="product_mobile">
      <el-row>
        <el-col :xs="24" :sm="12">
          <div class="product_mobile_content" style="padding-top: 50%; position: relative">
            <div
              style="
                position: absolute;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
              "
            >
              <div class="product_mobile_title font_size_30">
                {{ products[0].title }}
              </div>
              <div class="product_font_style product_mobile_content_one" v-for="(content, index) in products[0].content" :key="index">
                {{ content }}
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-row :gutter="20">
            <el-col span="12">
              <img :src="products[0].img[0].left" style="width: 100%" />
            </el-col>
            <el-col span="12">
              <img :src="products[0].img[0].right" style="width: 100%" />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <!-- 产品特点-->
    <div id="产品特点" class="product_spec_title head-label">
      <div style="text-align: center" class="font_size_24">产品特点</div>
    </div>
    <div class="product_spec_parent">
      <div class="border_one border_spec">
        <div class="border_spec_inner_one">
          <img :src="spec.product[0].img" style="width: 50px; height: 50px" />
          <div style="margin-left: 5px; font-weight: bold" class="font_size_24">
            {{ spec.product[0].title }}
          </div>
        </div>
        <div style="display: flex; flex-direction: column">
          <div class="border_spec_content_one">
            {{ spec.product[0].contents[0] }}
          </div>
          <div class="border_spec_inner_last">
            {{ spec.product[0].contents[1] }}
          </div>
        </div>
      </div>
      <div>
        <img :src="computeArrowImg" class="border_spec_img" />
      </div>
      <div class="border_spec">
        <div class="border_spec_inner_one">
          <img :src="spec.product[1].img" style="width: 50px; height: 50px" />
          <div style="margin-left: 5px; font-weight: bold" class="font_size_24">
            {{ spec.product[1].title }}
          </div>
        </div>
        <div style="display: flex; flex-direction: column">
          <div class="border_spec_content_one">
            {{ spec.product[1].contents[0] }}
          </div>
          <div class="border_spec_inner_last">
            {{ spec.product[1].contents[1] }}
          </div>
        </div>
      </div>
      <div>
        <img :src="computeArrowImg" class="border_spec_img" />
      </div>
      <div class="border_spec">
        <div class="border_spec_inner_one">
          <img :src="spec.product[2].img" style="width: 50px; height: 50px" />
          <div style="margin-left: 5px; font-weight: bold" class="font_size_24">
            {{ spec.product[2].title }}
          </div>
        </div>
        <div style="display: flex; flex-direction: column">
          <div class="border_spec_content_one">
            {{ spec.product[2].contents[0] }}
          </div>
          <div class="border_spec_inner_last">
            {{ spec.product[2].contents[1] }}
          </div>
        </div>
      </div>
      <div>
        <img :src="computeArrowImg" class="border_spec_img" />
      </div>
      <div class="border_spec" style="margin-right: 0">
        <div class="border_spec_inner_one">
          <img :src="spec.product[3].img" style="width: 50px; height: 50px" />
          <div style="margin-left: 5px; font-weight: bold" class="font_size_24">
            {{ spec.product[3].title }}
          </div>
        </div>
        <div style="display: flex; flex-direction: column">
          <div class="border_spec_content_one">
            {{ spec.product[3].contents[0] }}
          </div>
          <div class="border_spec_inner_last">
            {{ spec.product[3].contents[1] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { provinceAndCityData, pcTextArr, regionData, pcaTextArr, codeToText } from "element-china-area-data";
import { ElEmpty } from "element-ui";
import axios from "axios";
const instance = axios.create();
instance.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
export default {
  components: {
    ElEmpty,
  },
  name: "Index",
  data() {
    return {
      pcTextArr,
      place: {
        current: 0,
        end: "",
        searchtext: "{}",
        size: 999,
        start: "",
      },
      idx: "",
      companyName: "",
      tipShow: false,
      loading: false,
      listLoading: false,
      checkIdx: 0,
      miniQr: "",
      miniQrShow: false,
      businessList: [],
      origin: [],
      destination: [],
      show: false,
      sliders: [],
      rules: {
        name: [{ required: true, message: "请输入活动名称", trigger: "blur" }, { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }],
      },
      images: [
        {
          img: require("../../static/other/用户管理.png"),
          title: "用户管理",
          content: ["用户消费分析", "用户标签设定"],
        },
        {
          img: require("../../static/other/zxcx.jpg"),
          title: "专线查询",
          content: ["全国物流专线", "紧握手中无忧虑"],
        },
        {
          img: require("../../static/other/gscx.jpg"),
          title: "公司查询",
          content: ["各地物流公司", "服务项目随时查找"],
        },
        {
          img: require("../../static/other/tcfw.jpg"),
          title: "同城服务",
          content: ["市区短驳配套", "随时查找更方便"],
        },
        {
          img: require("../../static/other/hdgz.png"),
          title: "回单跟踪",
          content: ["专业路线跟踪", "贴心放心更安心"],
        },
      ],
      products: [
        {
          img: [
            {
              left: require("../../static/other/1.jpg"),
              right: require("../../static/other/2.jpg"),
            },
            {
              left: require("../../static/other/3.jpg"),
              right: require("../../static/other/4.jpg"),
            },
            {
              left: require("../../static/other/5.jpg"),
              right: require("../../static/other/6.jpg"),
            },
          ],
          title: "小程序查询更安心，语音输入更快捷",
          content: [
            "全国10万家直达专线",
            "线路，价格，网点信息一目了然",
            "所有公司位置共享，就近发货更方便",
            "一键拨号，一键导航再不用保存物流公司电话和位置",
            "异地发货全直达，不用中转，运费更节省",
            "信息实时更新，自主修改和纠错，信息更准确",
          ],
        },
      ],

      spec: {
        img: require("../../static/other/arrow.png"),
        product: [
          {
            img: require("../../static/other/手指.png"),
            title: "快速便捷",
            contents: ["超快时效全程可视", "专取专派极速送达"],
          },
          {
            img: require("../../static/other/店铺管理.png"),
            title: "体验良好",
            contents: ["实时的货物追踪", "物流信息查询更安心"],
          },
          {
            img: require("../../static/other/数据分析.png"),
            title: "降本增效",
            contents: ["自动化的服务", "减少人工提高效率"],
          },
          {
            img: require("../../static/other/助力零售.png"),
            title: "拓展业务",
            contents: ["开展新业务模式", "增加竞争力及份额"],
          },
        ],
      },
      company: [
        "江苏运联传媒集团有限公司始创于2006年，作为江苏地区首家物流行业传媒公司。从创建至今，随着物流专线的萌芽、发展、到今天物流市场相对成熟的整个过程当中，一直以“人无我有，人有我优，人优我新”的经营理念，一直坚持以“合法，规范，高效超值，热情”为服务宗旨。",
        "运联快车历经数年物流广告无序激烈的市场竞争，在行业内一直还能遥遥领先的地位，受到了市场的绝对认可!能够取得这样一个来之不易的奇迹，除了持续改进质量管理体系，充分理解超规客户和用户的需求，全方位提供高效服务之外，就是我们运联传媒率先采用了微信小程序新媒体方式、微信群机器人、微信公众号互联同线上能方便查阅，效益持久显现，这种专线物流类广告其简单、方便、实用、有效，所以越来受到广大专线物流和货源单位的欢迎,作为行业内公认的顶尖品牌完美无缺的广告组合，以科学均衡的发布频率，全面公认的品牌美誉，赢得了众多企业物流和物流企业的信任与支持，发展至今已经积累了一批数量最多、质量层次最高、实力雄厚的品牌专线物流等长期忠实客户。",
        " 运联快车也就自然而然地发展成为市场上绝大部分成熟的品牌专线和发展迅猛的潜力专线最佳长期的品牌展示平台;更是众多货源单位专线资源采购部门不可或缺的重要咨询渠道之一。",
        "运联快车微信小程序是一个大型专业物流平台，致力于解决国内大中小物流公司和工厂企业信息交流、专线查询、短驳调车、落地分流、物流企业配套服务平台，提升物流企业的形象，构建网络物流综合服务市场。物流企业后市场服务公司是一家专注于为物流企业提供全方位服务的公司。"
      ],
      carousel_height: "550px",
    };
  },
  methods: {
    changeStart(val) {
      console.log(val);
    },
    handelPlane() {
      if (this.idx == 1) {
        if (this.origin.length == 0 || this.destination.length == 0) {
          this.tipShow = true;
          return;
        } else {
          this.tipShow = false;
        }
        this.loading = true;
        this.place.start = this.origin[1].substring(0, 2);
        this.place.end = this.destination[1].substring(0, 2);
        // this.place.start = "南京";
        // this.place.end = "上海";
        this.$http.post("https://cloud.hxinsoft.com/hxinsoft-api/api/cmsline/getlist", this.place).then((res) => {
          if (res.data.code == "000000") {
            this.loading = false;
            res.data.data.forEach((ele) => {
              console.log(ele);
              if (JSON.parse(ele.logo)) {
                ele.logoUrl = "https://yunliantest.oss-cn-beijing.aliyuncs.com/" + JSON.parse(ele.logo).thirdUrl;
              } else {
                ele.logoUrl = "https://minio.hxinsoft.com/jiayuan/20231219061500/584ed5308b794a2ba1ef55fd0d925784.png";
              }
            });
            this.businessList = res.data.data;
            this.businessList.forEach((e) => {
              if (e.logoUrl.indexOf("undefined") != -1) {
                e.logoUrl = "https://minio.hxinsoft.com/jiayuan/20231219061500/584ed5308b794a2ba1ef55fd0d925784.png";
              }
            });
          }
        });
      }
      if (this.idx == 2) {
        this.getCompanyLists();
        console.log(12);
      }
    },
    getCompanyLists() {
      this.loading = true;
      instance.post("https://wuliuminiapi.jsylkc.com/company/getCompanyList", { name: this.companyName, searchtext: {}, offset: 0, limit: 10 }).then((res) => {
        if (res.data.code == "0") {
          this.loading = false;
          res.data.data.companyList.forEach((ele) => {
            if (JSON.parse(ele.logo)) {
              ele.logoUrl = "https://yunliantest.oss-cn-beijing.aliyuncs.com/" + JSON.parse(ele.logo).thirdUrl;
            } else {
              ele.logoUrl = "https://minio.hxinsoft.com/jiayuan/20231219061500/584ed5308b794a2ba1ef55fd0d925784.png";
            }
          });
          this.businessList = res.data.data.companyList;
          this.businessList.forEach((e) => {
            if (e.logoUrl.indexOf("undefined") != -1) {
              e.logoUrl = "https://minio.hxinsoft.com/jiayuan/20231219061500/584ed5308b794a2ba1ef55fd0d925784.png";
            }
          });
        }
      });
    },
    handleShow(e, index) {
      this.listLoading = true;
      this.checkIdx = index;
      instance
        .post(
          "https://cloud.hxinsoft.com/hxinsoft-wuliu/cmscompany/getCompanyCode",
          { id: e.id },
          {
            headers: {
              "client-type": "WULIU",
            },
          }
        )
        .then((res) => {
          if (res.data.code == "000000") {
            this.miniQrShow = true;
            this.listLoading = false;
            this.miniQr = "https://yunliantest.oss-cn-beijing.aliyuncs.com/" + res.data.data;
          } else {
            this.miniQrShow = true;
            this.listLoading = false;
            this.miniQr = "https://minio.hxinsoft.com/jiayuan/20231221053837/fcf29009521f49c7b59f3ca23878d472.jpg";
          }
        });
    },
    handleParent(idx) {
      this.idx = idx;
      this.show = true;
      this.businessList = [];
    },
    exchange() {
      if (this.origin && this.destination) {
        [this.origin, this.destination] = [this.destination, this.origin];
      }
    },
  },
  mounted() {
    this.sliders = [
      {
        img: require("../../static/slider/a1.png"),
      },
      {
        img: require("../../static/slider/a2.png"),
      },
      {
        img: require("../../static/slider/a3.png"),
      },
    ];
  },
  computed: {
    //计算高度
    computeHeight() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 430) {
        return "310px";
      } else {
        return "250px";
      }
    },
    computeArrowImg() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 450) {
        return require("../../static/other/arrow.png");
      } else {
        return require("../../static/other/arrow_down.png");
      }
    },
  },
};
</script>

<style scoped>
.border_parent {
  width: 90%;
  margin: auto;
}

.slider_img {
  height: 310px;
  width: 100%;
}

.solve {
  margin-top: 50px;
  margin-bottom: 30px;
}

.border {
  border-radius: 6px;
  border: 1px solid #ebeef5;
  height: auto;
  margin: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.border_one {
  margin-left: 0;
}

.border_img_parent {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.product_mobile_content {
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.product_mobile_img {
  width: 50%;
}

.product_mobile_title {
  font-weight: bold;
  text-align: center;
}

.product_pc_one {
  text-align: center;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.font_size_30 {
  font-size: 1.875em;
}

.product_font_style {
  font-size: 1.125em;
}

.product_pc_img {
  width: 100%;
}

.product_pc_img_div {
  width: 50%;
  float: left;
  display: flex;
  align-items: center;
}

.product_pc {
  display: flex;
  width: 90%;
  margin: 20px auto;
  background: #f2f6fc;
  align-items: center;
}

.product_spec_title {
  margin-top: 30px;
  margin-bottom: 10px;
}

.product_spec_parent {
  display: flex;
  width: 90%;
  margin: 20px auto;
  align-items: center;
  height: auto;
}

.cooperation_parent {
  display: flex;
  justify-content: center;
  width: 90%;
  margin: 20px auto;
  align-items: center;
  height: auto;
}

.border_spec {
  border-radius: 6px;
  border: 1px solid #ebeef5;
  float: left;
  width: 25%;
  height: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.about_me_p {
  font-size: 1.25em;
  font-weight: normal;
  padding: 0 20px;
  margin: 10px;
}

.border_title {
  font-family: "PingFang SC";
  margin-top: 10px;
  font-size: 1.125em;
  font-weight: bold;
  text-align: center;
}

.border_content_one {
  margin-top: 20px;
  font-size: 1.125em;
  text-align: center;
}

.border_content_two {
  margin-top: 5px;
  font-size: 1.125em;
  margin-bottom: 25px;
  text-align: center;
}

.img_border {
  margin-top: 15px;
  width: 80px;
  height: 80px;
}

.border_spec_inner_one {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 35px;
  height: 70px;
}

.border_spec_content_one {
  margin-top: 15px;
  font-size: 1.125em;
  float: left;
  text-align: center;
}

.border_spec_inner_last {
  margin-top: 15px;
  font-size: 1.125em;
  float: left;
  margin-bottom: 25px;
  text-align: center;
}

.cooperation {
  margin-top: 30px;
  width: 100%;
}

.about_me {
  display: flex;
  margin-top: 30px;
  justify-content: center;
  width: 100%;
}

.product_mobile {
  width: 90%;
  align-items: center;
  margin: 20px auto;
  background: #f2f6fc;
}

.product_mobile_img_div {
  width: 50%;
  height: auto;
}

.product_mobile_content_one {
  margin-top: 20px;
  text-align: center;
}

.product_mobile_content_two {
  margin-top: 10px;
  text-align: center;
}
.dialog ::v-deep .el-dialog {
  width: 50%;
  border-radius: 10px;
  overflow: hidden;
  overflow-y: auto;
  height: 600px;
}
::v-deep .el-dialog::-webkit-scrollbar {
  width: 0; /* 隐藏滚动条 */
}

.imagePic {
  /* margin-left: 35px; */
  /* width: 300px; */
}
.pic {
  width: 60px;
  height: 60px;
}
.miniQrShowDio ::v-deep .el-dialog {
  margin-top: 30vh !important;
  height: 350px;
  border-radius: 20px;
  width: 20%;
}
.list {
  border-bottom: 1px solid #ebeef5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.text {
  margin-left: 20px;
  font-size: 16px;
}
.text1 {
  margin-right: 10px;
  color: #008000;
  min-width: 80px;
}
.icon {
  width: 30px;
  height: 30px;
  margin-right: 10px;
  cursor: pointer;
}
.img {
  width: 200px;
  height: 200px;
}
.tip {
  font-size: 12px;
  color: red;
  margin-top: -10px;
}
.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 100px;
  font-size: 14px;
}
.flexdisp {
  display: flex;
  justify-content: center;
}
.cashIcon {
  width: 30px;
  margin: 0 15px;
  vertical-align: -10px;
  cursor: pointer;
}
/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 430px) {
  .slider_img {
    height: 65px;
    width: 100%;
  }

  .dialog ::v-deep .el-dialog {
    width: 90%;
  }
  .cashIcon {
    display: none;
  }
  ::v-deep .el-cascader {
    margin: 5px 20px;
  }
  .flexdisp {
    display: flex;
  }
  .img {
    width: 180px;
    height: 180px;
  }
  .dialog-footer {
    /* margin-top:5px; */
  }
  .imagePic {
    width: 260px;
    /* margin-left: 10px; */
  }
  .empty {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 50px;
    font-size: 14px;
  }
  .pic {
    width: 40px;
    height: 40px;
  }
  .miniQrShowDio ::v-deep .el-dialog {
    margin-top: 30vh !important;
    height: 320px;
    border-radius: 20px;
    width: 60%;
  }
  .text {
    margin-left: 10px;
    font-size: 14px;
  }
  .text1 {
    margin-right: 5px;
    color: #008000;
  }
  .icon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    cursor: pointer;
  }
  .list {
    border-bottom: 1px solid #ebeef5;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .slider_img {
    height: 250px;
    width: 100%;
  }

  .border_parent {
    display: flex;
    width: 90%;
    margin: auto;
    height: auto;
    flex-direction: column;
  }

  .border {
    border-radius: 6px;
    border: 1px solid #ebeef5;
    float: left;
    width: 100%;
    height: auto;
    margin: 10px 0 auto;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    /*background: aquamarine;*/
  }

  .border_img_parent {
    margin-top: 0;
  }

  .product_mobile {
    width: 90%;
    align-items: center;
    margin: 20px auto;
    height: auto;
    background: #f2f6fc;
  }

  .product_mobile_content {
    width: 100%;
    margin-top: 15px;
  }

  .product_mobile_content_one {
    margin-top: 5px;
  }

  .product_mobile_content_two {
    margin-top: 5px;
  }

  .product_mobile_img_div {
    display: flex;
    width: 100%;
    height: auto;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 15px;
  }

  .product_mobile_img {
    float: left;
  }

  .product_mobile_title {
    font-weight: bold;
  }

  .product_pc_one {
    width: 100%;
    margin-top: 15px;
  }

  .font_size_30 {
    font-size: 1.25em;
  }

  .product_font_style {
    font-size: 1em;
  }

  .product_pc_img {
    height: 280px;
    width: 320px;
  }

  .product_pc_img_div {
    width: 100%;
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
  }

  .product_pc {
    display: flex;
    width: 90%;
    height: auto;
    margin: 20px auto;
    background: #f2f6fc;
    flex-direction: column;
  }

  .head-label {
    display: flex;
    margin-top: 10px;
  }

  .product_spec_parent {
    display: flex;
    width: 90%;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    height: auto;
    flex-direction: column;
  }

  .border_spec {
    float: left;
    height: auto;
    margin: 8px;
    width: 100%;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .border_title {
    font-family: "PingFang SC";
    margin-top: 5px;
    font-size: 1.125em;
    font-weight: bold;
  }

  .border_content_one {
    margin-top: 5px;
    font-size: 1.125em;
  }

  .border_content_two {
    margin-top: 5px;
    font-size: 1.125em;
    margin-bottom: 8px;
  }

  .img_border {
    margin-top: 8px;
    width: 80px;
    height: 80px;
  }

  .border_spec_inner_one {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 8px;
    /*background-color: aqua;*/
    height: 70px;
  }

  .border_spec_content_one {
    margin-top: 5px;
    font-size: 1.125em;
    float: left;
  }

  .border_spec_inner_last {
    /*background-color: bisque;*/
    margin-top: 5px;
    font-size: 1.125em;
    float: left;
    margin-bottom: 8px;
  }

  .about_me {
    display: flex;
    margin-top: 10px;
    width: 100%;
  }
}

.border_spec_img {
  width: 75px;
  height: 55px;
  align-self: center;
}

.font_size_24 {
  font-size: 1.5em;
  margin: 30px;
}
</style>
